import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';


const EmployeCreate=React.lazy(()=>import('./Createform'))
const EmployeEdit=React.lazy(()=>import('./EditForm'))
const EmployeTable=React.lazy(()=>import('./Table'));


export const SpecialEmployeeConfigs = [
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/special-employee/create',
    element: <EmployeCreate />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/special-employee/edit/:id',
    element: <EmployeEdit />,
  },

  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/special-employee/listing',
    element: <EmployeTable/>,
  },
 

];
